import React from 'react';

import { FeatureConfig, Vertical } from 'utils/vertical';

type VerticalContextType = {
  domain: string;
  features: FeatureConfig;
  vertical: Vertical;
};

const VerticalContext = React.createContext<VerticalContextType | null>(null);

export const useVerticalContext = (): VerticalContextType => {
  const context = React.useContext(VerticalContext);

  if (context === null) {
    throw new ReferenceError('Vertical context is not defined');
  }

  return context;
};

const VerticalProvider: React.FunctionComponent<VerticalContextType> = ({ children, ...context }) => {
  return <VerticalContext.Provider value={context}>{children}</VerticalContext.Provider>;
};

export default VerticalProvider;
